import { withInstall, withNoopInstall } from '@zoryn/utils'
import AppShell from './src/app-shell.vue'
import AppTitleBar from './src/app-title-bar.vue'
import AppRail from './src/app-rail.vue'
import AppTagsBar from './src/app-tags-bar.vue'
import AppDomainNav from './src/app-domain-nav.vue'
import AppDomainMenu from './src/app-domain-menu.vue'

import type { SFCWithInstall } from '@zoryn/utils'

export const ZAppShell: SFCWithInstall<typeof AppShell> & {
  AppTitleBar: typeof AppTitleBar
  AppRail: typeof AppRail
  AppTagsBar: typeof AppTagsBar
  AppDomainNav: typeof AppDomainNav
  AppDomainMenu: typeof AppDomainMenu
} = withInstall(AppShell, {
  AppTitleBar,
  AppRail,
  AppTagsBar,
  AppDomainNav,
  AppDomainMenu,
})

export default ZAppShell
export const ZAppTitleBar: SFCWithInstall<typeof AppTitleBar> =
  withNoopInstall(AppTitleBar)
export const ZAppRail: SFCWithInstall<typeof AppRail> = withNoopInstall(AppRail)
export const ZAppTagsBar: SFCWithInstall<typeof AppTagsBar> =
  withNoopInstall(AppTagsBar)
export const ZAppDomainNav: SFCWithInstall<typeof AppDomainNav> =
  withNoopInstall(AppDomainNav)
export const ZAppDomainMenu: SFCWithInstall<typeof AppDomainMenu> =
  withNoopInstall(AppDomainMenu)

export * from './src/app-shell'
export * from './src/tag-nav'
export * from './src/types'
export type {
  AppShellInstance,
  AppTitleBarInstance,
  AppRailInstance,
  AppTagsBarInstance,
  AppDomainNavInstance,
  AppDomainMenuInstance,
} from './src/instance'
